import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { useDispatchActions, setStoreState } from './utils'
import { storageUtil } from '@/utils'
import type { IGuildInfo } from '@/types/interfaces';


const initialState: IGuildInfo = {
  allowCreate: false,
}

export const slice = createSlice({
  name: 'guildInfo',
  initialState,
  reducers: {
    setGuildInfo: (state, action: PayloadAction<IGuildInfo>) => {
      const payload = action.payload
      setStoreState(state, payload)
      storageUtil.setSessionStorage('guildInfo', JSON.stringify(payload))
    },
  },
})

export const { setGuildInfo: guildInfoActionCreator } = slice.actions
export const reducer = slice.reducer

export default function useGuildInfoStore() {
  const state = useSelector((state: RootState) => state.guildInfo)
  const storageState = storageUtil.getSessionStorage('guildInfo', true) || {}
  const actionPool = useDispatchActions(slice.actions)
  const totalState = { ...state, ...storageState }

  return {
    guildInfo: totalState,
    ...actionPool,
  }
}
